import React, { Component } from "react";

export default class Inspectors extends Component {
  render() {
    return <div>List of Outside Inspectors for this customer</div>;
  }
}



// WEBPACK FOOTER //
// ./src/customers/Inspector/Inspectors.js